module.exports = __webpack_public_path__ + "media/temp/drivethrurpg-de78d6fb.png";